// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"1799b694","673":"293d0f9f","767":"62ad3e4a"}[chunkId] + ".chunk.js";
};